import Vue from 'vue';
import styled, { css } from 'vue-styled-components';

import {
    ABSOLUTE_VERTICAL_CENTER,
    FLEX_CENTER,
    GRAY,
    square,
} from '@/styles/common.styled';
import {
    FLEX_COLUMN_DIV,
    FLEX_VERTICAL_CENTER_DIV,
} from '@styles/common.styled.component';

import _InputField from '@components/Common/InputField';
import _StatusInput from '@components/Common/StatusInput';

import { COLORS } from '@styles/common.styled';

export const Wrapper = styled.div`
    border-radius: 5px;
    background-color: white;
    width: 480px;
    @media screen and (max-width: 767px) {
        height: 100%;
        padding: 0;
        display: flex;
        flex-direction: column;
        max-width: 100%;
    }
`;

export const Body = styled(FLEX_COLUMN_DIV)`
    width: 100%;
    padding: 0;

    &:nth-child(2) {
        margin-top: 25px;
        border-top: 1px solid ${COLORS['gray-20']};
        padding-top: 20px;
    }
`;

export const InputField = styled(
    Vue.component('account-input-field', _InputField)
)`
    input {
        width: 100%;
        padding-left: 30px;
    }
`;

export const ColorCircle = styled('span', { bgColor: String })`
    width: 20px;
    height: 20px;
    border-radius: 10px;
    ${ABSOLUTE_VERTICAL_CENTER}
    left: 6px;
    transition: background-color 0.2s;
    /* background-color: ${R.propOr('#b72b2b', 'bgColor')}; */
    background-color: '#FF8F8F';
`;

export const Colors = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 320px;
    margin: 20px auto 0 auto;
    @media screen and (max-width: 767px) {
        width: 100%;
    }
`;

export const ColorBox = styled('span', { bgColor: String })`
    width: 40px;
    height: 40px;
    cursor: pointer;
    background-color: ${R.prop('bgColor')};
    @media screen and (max-width: 767px) {
        width: 12.5%;
    }
`;

export const ModalConfirmText = styled.p`
    padding-bottom: 8px;
    font-size: 16px;
    font-weight: normal;
    color: ${COLORS['gray-100']};
    white-space: pre-wrap;
`;

export const ModalTitle = styled.p`
    padding-bottom: 8px;
    font-size: 16px;
    font-weight: 500;
    color: ${COLORS['gray-100']};
`;

export const StatusInput = styled(
    Vue.component('account-status-input', _StatusInput)
)`
    width: 100%;
    & input {
        height: 44px;
        font-size: 14px;
    }

    .bottom-container {
        margin-top: 8px;
    }
`;

export const LabelWrapper = styled.div`
    margin: 16px 0 8px 0;
`;

export const TeamLabelWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    height: 44px;
`;

export const LabelText = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: ${COLORS['gray-100']};
`;

export const DeleteButtonCont = styled(FLEX_VERTICAL_CENTER_DIV, {
    deletable: Boolean,
})`
    margin: 16px 0 0 auto;
    font-size: 14px;
    svg {
        width: 16px;
        height: 16px;
        margin-right: 4px;
    }
    font-weight: 500;

    ${({ deletable }) =>
        deletable
            ? css`
                  cursor: pointer;
                  color: ${COLORS['blue-60']};
                  svg {
                      path {
                          fill: ${COLORS['blue-60']};
                      }
                  }
              `
            : css`
                  cursor: not-allowed;
                  color: ${GRAY(40)};
                  svg {
                      path {
                          fill: ${GRAY(40)};
                      }
                  }
              `};
`;

export const Row = styled.div`
    display: flex;
    align-items: flex-start;
    margin-top: 16px;

    &:first-child {
        margin-top: 8px;
    }

    &:last-child {
        margin-bottom: 8px;
    }

    .status-input-wrapper {
        width: calc(100% - 95px);
        margin-left: auto;
    }
`;

export const ScrollWrapper = styled.div`
    max-height: 224px;
    overflow-y: auto;
    @media screen and (max-height: 894px) {
        max-height: calc(100vh - 670px);
    }
`;

export const AccountIcon = styled('span', { color: String })`
    ${FLEX_CENTER}
    ${square(24)}
    border-radius: 50%;
    font-size: 14px;
    font-weight: 500;
    color: white;
    background-color: ${R.propOr('#0054C6', 'color')};
    cursor: pointer;
    flex-shrink: 0;
`;

export const CurrentNameWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    height: 44px;
    padding: 0 16px;
    border: 1px solid ${COLORS['gray-30']};
    border-radius: 2px;
    font-size: 14px;
    color: ${COLORS['gray-50']};
`;

export const CurrentNameText = styled.div`
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    &:nth-child(2) {
        margin-left: 8px;
    }
`;
